import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '@src/context/GlobalContextProvider';
import Cookies from 'js-cookie';
import { nanoid } from 'nanoid';
import React, { useContext, useEffect } from 'react';

export default function AnalyticsComponent({ children }) {
  const dispatch = useContext(GlobalDispatchContext);
  const state = useContext(GlobalStateContext);

  useEffect(() => {
    if (!state.id) {
      let id = nanoid();
      dispatch({
        type: 'SET_USER_ID',
        payload: id,
      });
    }
    if (
      window.location.hostname == 'www.crio.do' ||
      window.location.hostname == 'crio.do'
    ) {
      if (!Cookies.get('isBraveDataSent')) {
        fetch('https://api.duckduckgo.com/?q=useragent&format=json')
          .then((resp) => resp.json())
          .then((resp) => {
            var isBrave = resp['Answer'].includes('Brave');
            if (isBrave) {
              // console.log("isBrave", isBrave);

              fetch(
                `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=b&ua=${
                  window && window.navigator.userAgent.toLowerCase()
                }&url=${window && window.location.href}&uid=${state.id}`,
              )
                .then((resp) => resp.json())
                .then((resp) => {
                  Cookies.set('isBraveDataSent', 'true');
                });
            } else {
              Cookies.set('isBraveDataSent', 'true');
            }
          });
      }
      fetch('https://www.googletagmanager.com/gtm.js?id=GTM-KWQ3NRS&a')
        .then((resp) => resp.text())
        .then((resp) => {
          // console.log(resp)

          if (resp.length == 0 || !resp.includes('GTM-KWQ3NRS')) {
            //   console.log("GTM BLOCKED");
            if (!Cookies.get('isBlockDataSent')) {
              fetch(
                `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=g&ua=${
                  window && window.navigator.userAgent.toLowerCase()
                }&url=${window && window.location.href}&uid=${state.id}`,
              )
                .then((resp) => resp.json())
                .then((resp) => {
                  // console.log("gtm error event sent");
                  Cookies.set('isBlockDataSent', 'true');
                });
            }
          } else {
            Cookies.set('isBlockDataSent', 'true');
          }
        })
        .catch((err) => {
          // console.log("ERROR LOADING GTM");
          // console.log(err);
          fetch(
            `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=e&ua=${
              window && window.navigator.userAgent.toLowerCase()
            }&url=${window && window.location.href}&uid=${state.id}&error=${
              err.message
            }`,
          )
            .then((resp) => resp.json())
            .then((resp) => {
              // console.log("error event sent");
            });
        });
      if (document.readyState === 'complete') {
        console.log('DOMLoaded');
        scr();
      } else {
        console.log('DOM_LOADING');
        window.addEventListener('load', scr, false);
      }
    }
  }, []);
  const scr = function () {
    if (
      !(window && window.ga && window.ga.create) ||
      (window && window.ga && window.ga.toString().includes('len === 0')) ||
      (window &&
        window.ga &&
        window.ga.toString() ==
          `() {
    }`)
    ) {
      console.log('Google Analytics is not loaded');
      fetch(
        `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=gn&ua=${
          window && window.navigator.userAgent.toLowerCase()
        }&url=${window && window.location.href}&uid=${state.id}`,
      );
    }

    if (!(window && window.google_tag_manager)) {
      console.log('Google Tag Manager is not loaded');
      fetch(
        `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=gtn&ua=${
          window && window.navigator.userAgent.toLowerCase()
        }&url=${window && window.location.href}&uid=${state.id}`,
      );
    } else {
      if (
        !(
          window &&
          window.google_tag_manager &&
          window.google_tag_manager['GTM-KWQ3NRS']
        )
      ) {
        console.log('Google Tag Manager is not loaded - null');
        fetch(
          `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=gtn&ua=${
            window && window.navigator.userAgent.toLowerCase()
          }&url=${window && window.location.href}&uid=${state.id}`,
        );
      }
    }

    if (!(window && window.webengage)) {
      console.log('Webengage is not loaded');
      fetch(
        `https://script.google.com/macros/s/AKfycbw_8jprqdEawqbnvueoAnKbBLAudOS5W26gQQRTDPe7a1BSlZx5/exec?sheet=wn&ua=${
          window && window.navigator.userAgent.toLowerCase()
        }&url=${window && window.location.href}&uid=${state.id}`,
      );
    }
  };
  return <>{children}</>;
}
